import Link from 'next/link';
import React from 'react';

type Props = {
    title: string;
    subtitle: string;
    ctaLabel: string;
};

export const UnsubbedContainer: React.FC<Props> = ({ title, subtitle, ctaLabel }) => {
    return (
        <div className="unsubbed-container">
            <div className="cta-container">
                <h2 className="title">{title}</h2>
                <p className="subtitle">{subtitle}</p>
                <Link href="/dashboard/subscriptions">
                    <a className="button medium-button blue-button">{ctaLabel}</a>
                </Link>
            </div>
        </div>
    );
};
